var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m31.17164.17021l2.78909,6.78364,6.76709-2.83636-.01891,7.32727,7.32727-.01891-2.83637,6.76709,6.80018,2.80564-5.2,5.17164,5.2,5.17164-6.78363,2.78909,2.83637,6.76709-7.32727-.01891.01891,7.32727-6.76709-2.83637-2.80564,6.80018-5.17164-5.2-5.17164,5.2-2.78909-6.78363-6.76709,2.83637.01891-7.32727-7.32727.01891,2.83636-6.76709-6.80018-2.80564,5.2-5.17164L0,20.99858l6.78364-2.78909-2.83636-6.76709,7.32727.01891-.01891-7.32727,6.76709,2.83636L20.82836.17021l5.17164,5.2L31.17164.17021Z",
    fill: "#00be3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.47361,30.81402c1.92169-1.8748,3.82659-3.73224,5.73038-5.59084,2.14919-2.09816,4.3024-4.19225,6.44272-6.29944.59302-.58383,1.2714-.83195,2.06666-.58184.70345.22124,1.12676.74328,1.25695,1.47035.14478.80854-.25868,1.39286-.80873,1.92797-3.21993,3.13245-6.43229,6.27268-9.64653,9.41098-1.15861,1.13124-2.31211,2.26774-3.47391,3.39569-1.07962,1.04817-2.05493,1.05223-3.13289.00334-2.37724-2.31314-4.74971-4.63119-7.11938-6.9521-.95305-.93344-1.04547-2.00891-.26151-2.83855.77759-.82288,1.93916-.76493,2.90048.16679,2.00589,1.94413,4.00303,3.89728,6.04575,5.88764Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.c485bf574e525466c01dc1660c22a7f7.svg";
export { ForwardRef as ReactComponent };